<template>
  <VLink
    :to="{ name: 'biz-categories-slug', params: { slug } }"
    class="p-4 -mt-px bg-white border -ms-px dark:text-white dark:shadow sm:rounded-md ring-primary-100 lg:hover:ring-2 lg:hover:border-primary-100 dark:bg-gray-900 dark:ring-gray-700 dark:hover:border-gray-700 dark:hover:ring-1 dark:border-gray-800 dark:border-2"
  >
    <StoreCategoryMedia :value="media" :alt="name" />
    <p class="dark:text-white">{{ name }}</p>
    <span class="block mt-1 text-sm leading-none text-gray-500">
      {{ $t("qty_items", [count]) }}
    </span>
  </VLink>
</template>

<script>
export default {
  props: {
    slug: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
    count: {
      type: Number,
      default: null,
    },
    media: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
